import {store} from "../redux/store";

/**
 * Get the current username from the store in a non react way. Used by purchase plugin. Ideally
 * use useUsername() hook in react components instead.
 */
export const getCurrentUsername = () => {
    return store.getState().auth?.session?.user_id;
};
